import { type ReactElement } from 'react'
import { type RenderRequestServerData, type UserAgentString } from 'src/lib/services/server-data'

import { useAppInit } from '@lib/hooks/app'
import { CommonServicesContext } from '@lib/services'

import { PixelTrackerContext } from '@contexts/pixel-tracker-context'

export interface BasePageProps {
  requestData?: RenderRequestServerData
  userAgent?: UserAgentString
  queryParams?: Record<string, string | string[] | undefined>
}

export function withServices<T extends object>(
  Component: (props: T) => ReactElement,
): (props: T & BasePageProps) => ReactElement {
  return ({ requestData, userAgent, queryParams, ...pageProps }) => {
    const [commonServices, pixelTracker] = useAppInit(requestData, userAgent, queryParams)

    return (
      <CommonServicesContext.Provider value={commonServices}>
        <PixelTrackerContext.Provider value={pixelTracker}>
          <Component {...(pageProps as T)} />
        </PixelTrackerContext.Provider>
      </CommonServicesContext.Provider>
    )
  }
}
